import type { DocumentRepository } from "../repositories/document-repository"

export const makeDeleteDocument = (repo: DocumentRepository) =>
  (id: string) =>
    repo.delete(id)
